import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: ButtonProps) {
  const sharedProps = {
    whileHover: {
      scale: 1.02
    },
    whileTap: {
      scale: 0.98
    },
    animate: {
      boxShadow: ['0px 0px 0px 0px rgba(201, 123, 99, 0.4)', '0px 0px 0px 15px rgba(201, 123, 99, 0)']
    },
    transition: {
      boxShadow: {
        duration: 2,
        repeat: Infinity
      }
    },
    className: `
      bg-[#C97B63] text-white font-bold py-4 px-8 rounded-full shadow-lg
      hover:bg-[#b56a54] transition-colors duration-300
      text-lg md:text-xl uppercase tracking-wide inline-block text-center
      ${fullWidth ? 'w-full' : ''}
      ${className}
    `
  };
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" {...sharedProps} data-id="element-187">
        {children}
      </motion.a>;
  }
  return <motion.button onClick={onClick} {...sharedProps} data-id="element-188">
      {children}
    </motion.button>;
}